import cn from "classnames";
import { FormTemplate } from "components/modal/templates";
import { Datetime } from "components/shared/form";
import { formatDateTimezone, getPointTime } from "helpers/bidpoint";
import { plainDate } from "helpers/date";
import { getInitialStateFromConfig } from "helpers/form";
import React from "react";
import { setBidPointDates } from "sources/books/bids";

const config = {
    bidId: {},
    bidPoint: {},
};

const pointConfig = {
    enteredAtByLogist: {
        label: "Дата прибытия на точку",
        inputProps: { name: "enteredAtByLogist" },
    },
    loadUnloadedAtByLogist: {
        label: "Дата загрузки/выгрузки",
        inputProps: { name: "loadUnloadedAtByLogist" },
    },
};

const initialState = getInitialStateFromConfig(config);

class SetBidPointDates extends FormTemplate {
    sendRequest = (stateData) => {
        return setBidPointDates(stateData);
    };

    renderBidPoint = () => {
        const { bidPoint } = this.props;
        return (
            <>
                <div className="row form-group">
                    <label className="col-sm-4 col-md-4 col-form-label col-form-label-sm text-md-right text-sm-left">
                        Адрес
                    </label>
                    <div className="col-sm-8 col-md-8 col-form-label-sm">
                        {bidPoint.geozone.address}
                        &nbsp;
                        <span className="text-muted">{formatDateTimezone(bidPoint)}</span>
                    </div>
                </div>
                {this.renderDateField(pointConfig.enteredAtByLogist)}
                {this.renderDateField(pointConfig.loadUnloadedAtByLogist)}
            </>
        );
    };

    setDateValue = ({ name, value }) => {
        const { bidPoint } = this.state;
        this.setState({ bidPoint: { ...bidPoint, [name]: value ? plainDate(value) : null } });
    };

    renderDateField = (props) => {
        const { bidPoint } = this.state;
        const bWrapper = cn("row", { "mb-2": !bidPoint.errors[props.inputProps.name] });
        return (
            <Datetime
                inPortal
                bWrapper={bWrapper}
                wrapper="col-sm-8 col-md-4"
                labelWrapper="col-sm-4 col-md-4 col-form-label col-form-label-sm text-md-right text-sm-left"
                errorWrapper="col-sm-8 col-md-8 offset-sm-4 offset-md-4"
                label={props.label}
                inputProps={{
                    name: props.inputProps.name,
                    type: "datetime",
                }}
                libOptions={{
                    name: props.inputProps.name,
                    autoComplete: "off",
                }}
                onChange={(prop) => this.setDateValue(prop)}
                value={bidPoint[props.inputProps.name]}
            />
        );
    };

    renderBodyInner = () => {
        return this.renderBidPoint();
    };
}

const ConfiguredModal = (props) => {
    const { bidPoint } = props;
    const { id, autoEnteredAt, autoLeavedAt, enteredAt, loadUnloadedAt, enteredAtByLogist, loadUnloadedAtByLogist } =
        bidPoint;
    initialState.bidPoint = {
        id,
        enteredAtByLogist: getPointTime(enteredAtByLogist, autoEnteredAt, enteredAt),
        loadUnloadedAtByLogist: getPointTime(loadUnloadedAtByLogist, autoLeavedAt, loadUnloadedAt),
        errors: {},
    };
    initialState.bidId = props.bid.id;
    return <SetBidPointDates {...props} config={config} initialState={initialState} />;
};

export default ConfiguredModal;
